import { Inbox } from 'lucide-react';
import { Flex, Box, Text } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { pxToRem } from '@duke-hq/ui/constants/scalable';

export default function NoDataMessage() {
  return (
    <Flex
      direction="column"
      align="center"
      justify="top"
      mt="8"
      textAlign="center"
      color="fg.muted"
    >
      <Box mb={2}>
        <Inbox size={pxToRem(48)} aria-hidden="true" color="currentColor" />
      </Box>

      <Text fontSize="xs">
        <Trans>Nothing to display here at the moment.</Trans>
        <br />
        <Trans>Remove any filters or try again later.</Trans>
      </Text>
    </Flex>
  );
}
